/**
 * Creates Unleash context information with chain data
 * @param {Object} storeConfig - Store configuration object (optional)
 * @returns {Object} Unleash context object
 */
export function createUnleashInfo(storeConfig = null) {
  // Get chain name from storeConfig or localStorage
  let chainName = null
  
  if (storeConfig && storeConfig?.chain_name) {
    chainName = storeConfig?.chain_name
  } else {
    chainName = localStorage.getItem('chainName')
  }

  // Create context object for Unleash
  const context = {}

  // Add chain to context if available
  if (chainName) {
    context.chain = chainName
  }

  return context
}

